/* eslint-disable */
const HEADER_STATE = {
	userLogo: '',
	howToModalCount: "0",
	openHowToModalFlag: false,
	refreshUserLogo: false
};
export default HEADER_STATE;
